module.exports = {"511102004":"大佛街道","511102006":"通江街道","511102008":"海棠街道","511102009":"绿心街道","511102010":"全福街道","511102101":"牟子镇","511102102":"土主镇","511102103":"白马镇","511102104":"茅桥镇","511102105":"青平镇","511102106":"苏稽镇","511102107":"水口镇","511102108":"安谷镇","511102109":"棉竹镇","511102116":"平兴镇","511102117":"悦来镇","511102118":"剑峰镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511102.json
// module id = 2460
// module chunks = 0